var XMLFile = require('../xml/XMLFile');

/**
 * This class represents the app.xml within the generated Excel. The
 * App contains information about the application that created the
 * Office Open XML Spreadsheet.
 *
 * @param {Object} [oContext] - Context object containing metadata for this particular Excel
 * @param {string} [oContext.application] - Application that created this Excel
 * @param {string} [oContext.version] - Application version that was used to create this Excel
 * @constructor
 */
function App(oContext) {
	XMLFile.call(this, App.metadata);

	if (oContext) {

		if (oContext.application) {
			this.application.value = oContext.application;
		}

		if (oContext.version) {
			this.version.value = oContext.version;
		}
	}
}

App.prototype = Object.create(XMLFile.prototype);
App.prototype.constructor = App;

App.metadata = {
	path: 'docProps/',
	filename: 'app.xml',
	tag: 'Properties',
	root: true,
	attributes: [
		{
			name: 'xmlns',
			value: 'http://schemas.openxmlformats.org/officeDocument/2006/extended-properties'
		},
		{
			name: 'xmlns',
			suffix: 'vt',
			value: 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes'
		}
	],
	properties: [
		{
			id: 'application',
			tag: 'Application',
			value: 'SAP UI5' // Default value, can be overridden
		},
		{
			tag: 'DocSecurity',
			value: '0'
		},
		{
			tag: 'Company',
			value: 'SAP SE'
		},
		{
			tag: 'SharedDoc',
			value: 'false'
		},
		{
			id: 'version',
			tag: 'AppVersion',
			value: '1.68' // Default value, can be overridden
		}
	]
};

module.exports = App;


//////////////////
// WEBPACK FOOTER
// ./core/xlsx/src/objects/App.js
// module id = 20
// module chunks = 0